/**
 * Runtime (Zod) validators for the Business Concepts API request bodies.
 * Mirrors summary and search requests in
 * `plugins/wb-marketplace-backend/src/service/businessConcepts/openapi.yaml`.
 * Query-parameter-shaped requests are validated by the generated OpenAPI
 * router and do not need a Zod schema here.
 */
import { z } from 'zod';

/** Per stable configured relation name; zero is meaningful, not absence. */
export const businessConceptRelationCountsZod = z.record(
  z.number().int().nonnegative().finite(),
);

export const businessConceptSummariesRequestZod = z
  .object({
    iris: z.array(z.string().min(1)).min(1).max(1000),
  })
  .strict();

export const businessConceptMatchByLabelRequestZod = z
  .object({
    labels: z.array(z.string().min(1)).min(1).max(1000),
    caseInsensitive: z.boolean().optional(),
  })
  .strict();

export const businessConceptSearchRequestZod = z
  .object({
    term: z.string().min(1),
    category: z.enum(['iri', 'summary']).optional(),
    offset: z.number().int().min(0).optional(),
    limit: z.number().int().min(1).max(1000).optional(),
    conceptKinds: z
      .array(z.enum(['concept', 'propertyConcept', 'rootConcept']))
      .min(1)
      .optional(),
  })
  .strict();

export type BusinessConceptSearchRequestInput = z.infer<
  typeof businessConceptSearchRequestZod
>;
